export const truncate = (text: string) => {
  return text.length > 19 ? `${text.slice(0, 17)}...` : text;
};
